import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import SInput from 'SharedComponents/ui/Input/SInput.vue';
import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'NumberParameter' },
  __name: 'Number',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {



const props = __props;
const emit = __emit;

const { innerValue, emitValue } = useValue(props, emit);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SInput, {
    modelValue: _unref(innerValue),
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => (_isRef(innerValue) ? (innerValue).value = $event : null)),
      _unref(emitValue)
    ],
    modelModifiers: { number: true },
    clearable: "",
    outlined: "",
    dense: "",
    "hide-bottom-space": "",
    type: "number"
  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
}
}

})